import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useAuth } from '../../contexts/AuthContext';
import Alert from '@mui/material/Alert';

export default function StrategiesLibraryPage() {
  const { currentUser, isAdmin } = useAuth();
  const [selectedStrategy, setSelectedStrategy] = useState(null);

  if (!isAdmin) {
    return <Alert severity="error">You do not have permission to access the Strategies Library.</Alert>;
  }

  return (
    <Paper elevation={1} sx={{ p: { xs: 1, sm: 2, md: 3 }, maxWidth: 1400, mx: 'auto', mt: 3 }}>
      {selectedStrategy ? (
        <Box>
          <Button
            variant="outlined"
            onClick={() => setSelectedStrategy(null)}
            sx={{ mb: 2 }}
          >
            ← Back to Strategies Library
          </Button>
          <StrategyLibraryBlocksSection
            currentUser={currentUser}
            selectedStrategyId={selectedStrategy.id}
          />
        </Box>
      ) : (
        <StrategiesLibraryTable
          currentUser={currentUser}
          onSelectStrategy={setSelectedStrategy}
        />
      )}
    </Paper>
  );
} 